if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
 
        this.form = this.querySelector('form');
        if (!this.form) return;
 
        // ✅ Prevent binding twice (can happen when HTML is injected / re-processed)
        if (this.form.dataset.productFormBound === 'true') return;
        this.form.dataset.productFormBound = 'true';
 
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;
 
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
 
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
 
        this.hideErrors = this.dataset.hideErrors === 'true';
 
        // Bind once
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this.onSubmitHandler);
      }
 
      onSubmitHandler(evt) {
        // ✅ Stop other submit listeners from firing too
        evt.preventDefault();
        evt.stopImmediatePropagation();
 
        if (!this.submitButton) return;
 
        // ✅ Hard lock to prevent double-add (2 items)
        if (this.form.dataset.submitting === 'true') return;
        this.form.dataset.submitting = 'true';
 
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          delete this.form.dataset.submitting;
          return;
        }
 
        this.handleErrorMessage();
 
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
 
        const spinner = this.querySelector('.loading-overlay__spinner');
        spinner && spinner.classList.remove('hidden');
 
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
 
        const formData = new FormData(this.form);
 
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
 
        config.body = formData;
 
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.description,
                message: response.message,
              });
 
              this.handleErrorMessage(response.description);
 
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
 
              this.submitButton.setAttribute('aria-disabled', true);
              const span = this.submitButton.querySelector('span');
              span && span.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
 
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
 
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            }
 
            this.error = false;
 
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  }, 0);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
 
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
 
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
 
            const spinner = this.querySelector('.loading-overlay__spinner');
            spinner && spinner.classList.add('hidden');
 
            // ✅ Release lock
            delete this.form.dataset.submitting;
          });
      }
 
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
 
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
 
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
 
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
 
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
 
class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('footer')?.classList.add('sticky-cart-modal_bottom_padding');
  }
 
  update() {
    const formEl = document.getElementById(`product-form-${this.dataset.section}`);
    if (!formEl) return;
 
    const addButton = formEl.querySelector('[name="add"]');
    if (!addButton) return;
 
    const rangeToShowModal = this.getTop(addButton) + formEl.clientHeight;
 
    if (window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')) {
      this.classList.add('show-modal');
      document.body.classList.add('modal__sticky-cart');
    }
 
    if (window.scrollY < rangeToShowModal && this.classList.contains('show-modal')) {
      this.classList.remove('show-modal');
      document.body.classList.remove('modal__sticky-cart');
    }
  }
 
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);